export { ErrorContent } from './Error';
export { CustomContent } from './Custom';
export { useLocalizedLandingPage } from './useLocalizedLandingPage';
export { useDynamicLocalizedLandingPage } from './useDynamicLocalizedLandingPage';
export { useAffiliateColors } from './useAffiliateColors';

export type { LandingPageProps, PageProps } from './LandingPageProps';
